export type TikTokModel = {
  image: string
  url: string
}

interface TikTokSerializerInput {
  url: string
  image: {
    url: string
  }
}

export function TikTokSerializer(tiktok: TikTokSerializerInput): TikTokModel {
  return {
    url: tiktok.url,
    image: tiktok.image.url,
  }
}
